import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";

import Loader from "../../components/NewView/Common/Loader";

const AboutUsComponent = React.lazy(() =>
  import("../../components/NewView/RootComponents/AboutUsComponent")
);

const AboutUsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>Хто ми | Yellow Hub Харків - Єловхаб та кар'єрний центр</title>
          <meta
            name="description"
            content="Yellow Hub Харків, також Єловхаб, Єлов Хаб, Еллоу Хаб або YellowHub, - кар'єрний центр працевлаштування та перекваліфікації від благодійного фонду Жовта Допомога."
          />
          <meta
            name="keywords"
            content="Yellow Hub, YellowHub, Єловхаб, Єлов Хаб, Еллоу Хаб, Йеллоу Хаб, Еловхаб, хто ми, Жовта Допомога, кар'єрний центр, працевлаштування Харків, перекваліфікація Харків, допомога ВПО, безкоштовні кар'єрні консультації"
          />
          <link rel="canonical" href="https://yellowhub.com.ua/about" />
          <meta property="og:title" content="Хто ми - Yellow Hub Харків" />
          <meta
            property="og:description"
            content="Кар'єрний центр Yellow Hub допомагає людям пройти шлях від невизначеності до стабільної роботи через консультації, навчання та перекваліфікацію."
          />
          <meta property="og:url" content="https://yellowhub.com.ua/about" />
          <meta property="og:type" content="website" />
        </Helmet>
        <AboutUsComponent />
      </Suspense>
    </Fragment>
  );
};

export default AboutUsPage;
